import {
  IconArrowRight,
  IconLightningBolt,
  IconLockCloseOutline,
  IconCheckDefault,
} from '@iwoca/icons';
import { Trans, useLingui } from '@lingui/react/macro';

import styles from './IntroScreen.module.css';
import { Button } from '../../Button/Button';
import { ExitToSignupLink } from '../components/ExitToSignupLink';

type TProps = {
  onStart: () => void;
};

export const IntroScreen = ({ onStart }: TProps) => {
  const { t } = useLingui();

  return (
    <div className={styles.container}>
      <p className={styles.eyebrow}>
        <IconLightningBolt className={styles.eyebrowIcon} />
        <Trans>2 minutes · 4 short questions</Trans>
      </p>
      <h1 className={styles.headline}>
        <Trans>
          Is an iwoca loan right for{' '}
          <span className={styles.accent}>your business</span>?
        </Trans>
      </h1>
      <p className={styles.lead}>
        <Trans>
          Find out in just two minutes — every question is optional. At the end
          you'll see your assessment. Non-binding and with no impact on your
          score.
        </Trans>
      </p>
      <Button
        variant="primary"
        onClick={onStart}
        aria-label={t`Start credit check`}
        type="button"
      >
        <Trans>Start credit check</Trans>
        <IconArrowRight />
      </Button>
      <ul className={styles.badges}>
        <li className={styles.badge}>
          <IconLockCloseOutline className={styles.badgeIcon} />
          <Trans>Free & non-binding</Trans>
        </li>
        <li className={styles.badge}>
          <IconCheckDefault className={styles.badgeIconCheck} />
          <Trans>No score impact</Trans>
        </li>
        <li className={styles.badge}>
          <IconCheckDefault className={styles.badgeIconCheck} />
          <Trans>No registration required</Trans>
        </li>
      </ul>
      <ExitToSignupLink phase="intro" />
    </div>
  );
};
